import React from 'react';

export const CompanyInfo = {
  fields: {
    title: {
      type: 'text',
      label: 'Titel'
    },
    description: {
      type: 'textarea',
      label: 'Beschreibung'
    },
    imageUrl: {
      type: 'text',
      label: 'Bild URL'
    }
  },
  render: ({ title, description, imageUrl }) => (
    <div className="py-16 px-4 bg-white dark:bg-slate-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-6">{title || 'Titel eingeben'}</h2>
            <p className="text-slate-600 dark:text-slate-300 leading-relaxed whitespace-pre-line">
              {description || 'Beschreibung eingeben'}
            </p>
          </div>
          {imageUrl && (
            <div>
              <img 
                src={imageUrl} 
                alt="Unternehmen" 
                className="w-full h-64 object-cover rounded-lg shadow-lg"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
};
